export default __webpack_public_path__ + "static/media/TermsConditions.1f822cd0.pdf";